var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"outBox"},_vm._l((_vm.list),function(item,index){return _c('div',{key:item[_vm.key1]},[_c('div',{class:_vm.computedClass(item) ? 'active default' : 'default',on:{"click":function($event){return _vm.clickTabs(item, index)}}},[_c('div',{staticClass:"tabs"},[_vm._v(" "+_vm._s(item.title)+" ")])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }